import { useEffect, useState } from "react";
import { fetchData, fileUrl } from "../../APIs/useMyAPI";
import { Row, Col } from "../../Grid-system";
import { Title, CardBox } from "../../components";
import Loading from "../../Tools/Loading";

const AutomationAnalytics = () => {
  const [automations, setAutomations] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // date filters
  const [filters, setFilters] = useState({
    startDate: getDefaultStart(),
    endDate: getDefaultEnd(),
  });

  useEffect(() => {
    fetchAutomationList();
  }, []);

  useEffect(() => {
    fetchAnalyticsData();
  }, [filters]);

  const fetchAutomationList = async () => {
    const res = await fetchData(`admin/automated/fetch/apis`, {}, "GET");
    setAutomations(res.data || []);
  };

  const fetchAnalyticsData = async () => {
    setIsLoading(true);
    await fetchData(
      `admin/automated/automation-analytics`,
      {
        start_date: filters.startDate,
        end_date: filters.endDate,
      },
      "POST"
    )
      .then((res) => {
        const apiData = res.data || [];

        // 🧮 Group totals by automation_reference
        const grouped = {};
        apiData.forEach((row) => {
          const key = row.automation_reference;
          if (!grouped[key]) {
            grouped[key] = {
              automation_reference: key,
              automation_name: row.automation_name,
              logo: row.logo,
              total: 0,
            };
          }
          grouped[key].total += parseFloat(row.total);
        });

        // Convert grouped object to array
        setData(Object.values(grouped));
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  function getDefaultStart() {
    const d = new Date();
    d.setDate(d.getDate() - 7); // last 7 days
    return formatDateTime(d);
  }

  function getDefaultEnd() {
    const d = new Date();
    return formatDateTime(d);
  }

  function formatDateTime(date) {
    const y = date.getFullYear();
    const m = `0${date.getMonth() + 1}`.slice(-2);
    const d = `0${date.getDate()}`.slice(-2);
    const h = `0${date.getHours()}`.slice(-2);
    const i = `0${date.getMinutes()}`.slice(-2);
    return `${y}-${m}-${d}T${h}:${i}`;
  }

  // total of all APIs
  const totalSum = data.reduce((sum, item) => sum + item.total, 0);

  return (
    <div>
      <Row justify={"between"}>
        <Col md={4}>
          <Title title="Automation Analytics (Total per API)" />
        </Col>
      </Row>

      <Row className="mt-4 mb-6">
        <Col md={3}>
          <label className="block text-gray-400 mb-1">Start Date & Time</label>
          <input
            type="datetime-local"
            value={filters.startDate}
            onChange={(e) =>
              setFilters((f) => ({ ...f, startDate: e.target.value }))
            }
            className="w-full py-2 border-2 border-Pink rounded-xl text-center bg-transparent"
          />
        </Col>

        <Col md={3}>
          <label className="block text-gray-400 mb-1">End Date & Time</label>
          <input
            type="datetime-local"
            value={filters.endDate}
            onChange={(e) =>
              setFilters((f) => ({ ...f, endDate: e.target.value }))
            }
            className="w-full py-2 border-2 border-Pink rounded-xl text-center bg-transparent"
          />
        </Col>
      </Row>

      {isLoading ? (
        <Loading />
      ) : (
          <div className="bg-white rounded-3xl ">
          <table className="min-w-full text-sm text-gray-300">
            <thead className="border-b border-gray-600 text-black uppercase text-xs">
              <tr>
                <th className="px-3 py-2 text-left">Logo</th>
                <th className="px-3 py-2 text-left">API Name</th>
                <th className="px-3 py-2 text-left">Total (USD)</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => {
                // match logo/name from automation list (prefer fresh data)
                const api = automations.find(
                  (a) => a.id == item.automation_reference
                );
                const name = api?.name || item.automation_name;
                const logo = api?.logo || item.logo;
                return (
                  <tr
                    key={idx}
                    className="border-b border-gray-700 text-black "
                  >
                    <td className="px-3 py-2">
                      {logo ? (
                        <img
                          src={`${fileUrl}${logo}`}
                          alt={name}
                          className="w-8 h-8 rounded-full object-contain"
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="px-3 py-2">{name}</td>
                    <td className="px-3 py-2 text-Pink font-semibold">
                      {item.total.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {data.length === 0 && (
            <div className="text-center text-gray-400 py-6">
              No data found for selected range.
            </div>
          )}

          {data.length > 0 && (
            <div className="mt-4 text-Pink text-right text-lg font-semibold">
              Grand Total: {totalSum.toFixed(2)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AutomationAnalytics;
